import { createFileRoute } from '@tanstack/react-router'
import EditionEndPapers from 'Edition/components/sections/Layout/EditionEndPapers'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout-composition')({
    component: EditionEndPapers,
})
